import React from 'react';
import BaseModal from 'src/common/components/Modal';
import notice from 'src/common/components/Notice';
import UtilInputs from 'src/common/components/UtilInputs';
import { editForm } from '../utils/list_data';
import { institutionsAPI } from 'src/api/modules/institutions';

const EditOrg = ({
	open,
	color = 'secondary',
	onClose,
	onSuccess,
	organization,
	onChangeData,
}) => {
	const onSave = () => {
		institutionsAPI
			.institucionCRUD(4, 'OR', organization.nombre, organization.id, organization.prefijo)
			.then(() => {
				onSuccess('Organización actualizada', 'success', 2);
			})
			.catch(() => {
				notice('Ha ocurrido un error en su solicitud');
			});
	};

	return (
		<BaseModal
			open={open}
			mainText="Editar Organización"
			onConfirm={onSave}
			confirmLabel="Guardar"
			onClose={onClose}
			onCancel={onClose}
		>
			<UtilInputs
				formValues={organization}
				inputValues={editForm}
				onValuesChange={onChangeData}
			/>
		</BaseModal>
	);
};

export default EditOrg;
